import { PostTypeEnum } from "@/services/posts/types";

export function checkBackgroundColor(renderChannel: any, callback: Function) {
    if (!renderChannel.css) return;
    const type = renderChannel.postType.toLowerCase();

    if (type !== PostTypeEnum.html.toLowerCase() &&
    type !== PostTypeEnum.clock.toLowerCase() &&
    type !== PostTypeEnum.date.toLowerCase() &&
    type !== PostTypeEnum.rss.toLowerCase()) return;

    for (const [key, value] of Object.entries(renderChannel.css)) {
        if (value !== "") {
            let dummy: HTMLDivElement | null = document.createElement("div");
            dummy.style.cssText = (value as string);
            const color = dummy.style.color;
            dummy = null; // Null the original reference so it isn't stored.

            if (color !== null && color !== "") {
                if (color === "white") {
                    callback();
                    return;
                } else {
                    // If it's not "white", we calculate the luminance to determine brightness.
                    // If it's near white, swap the background to gray
                    const match = color.match(/rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/);
                    const colors = match ? {
                        red: match[1],
                        green: match[2],
                        blue: match[3]
                    } : {};
                    if (colors === {}) return;
                    const lum = 0.2126 * Number(colors.red) + 0.7152 * Number(colors.green) + 0.0722 * Number(colors.blue);
                    if (lum > 220) {
                        callback();
                        return;
                    }
                }
            }
        }
    }
}
